import {useContext} from "react";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {GlobalContext} from "../../stores/GlobalStore";

const useCheckExpiration = () => {
    const {dispatch} = useContext(GlobalContext);
    const {t} = useTranslation();
    const location = useLocation();

    const findUrlExpires = () => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get("expires");
    };

    return () => {
        const expires = findUrlExpires();
        if (expires && expires < Math.floor(Date.now() / 1000)) {
            dispatch({
                type: "SET_ERROR",
                payload: {message: t("error.sessionExpired")},
            });
            return true;
        }
        return false;
    };
};

export default useCheckExpiration;
